<div *ngIf="openGenerateAPi ">
    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-icon style="cursor: pointer;" mat-dialog-close>close</mat-icon>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" style="width:29vw">
        <label mat-dialog-title class="apiKeyHeader">Are you sure that you want to generate API Key?</label>
        <p class="apiKey-sublabel">Please note that your API Key can only be generated if KYC is verified</p>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
        <button type="button" class="verify-btn" fxFlex="30" fxLayoutAlign="center center" style="padding: 8px 0;background-color: #fff;"
        (click)="closePopup()" >No<mat-icon>
            chevron_right
          </mat-icon></button>
        <button type="button" class="verify-btn" fxLayoutAlign="center center" fxFlex="30" style="padding: 8px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
      font-style: normal;font-size: 14px; " (click)="GenerateOtpPopup();getApiKeyOTP()">Yes<mat-icon>
            chevron_right
          </mat-icon>
        </button>
      </div>
</div>
<div  *ngIf="!openGenerateAPi">
    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-icon style="cursor: pointer;" mat-dialog-close>close</mat-icon>
    </div>
    <div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <h2><mat-icon style="color:green;font-size: 50px;">check_circle</mat-icon></h2>
        <h3 class="key-label">Congratulations!</h3>
        <p class="kyc-verify-sub-label">Your API key is generated</p>
        <!-- <label>{{apiKey}}</label> -->
        <button type="button" mat-button (click)="goToCreateBot()" class="verify-btn" fxLayoutAlign="center center"
        style="padding:2px;background: #386AF6; color:#fff;border: 2px solid #386AF6;border-radius: 25px; width:16vw" >Create Bot
        <mat-icon>
            chevron_right
        </mat-icon>
    </button>
    </div>
</div>
<!-- <div *ngIf="showError">
    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-icon style="cursor: pointer;" mat-dialog-close>close</mat-icon>
    </div>
    <div mat-dialog-content fxLayout="column" fxLayoutAlign="center center"  style="width:40vw"> 
        <h2><mat-icon style="color:#F8B200;
            ;font-size: 50px; ">error</mat-icon></h2>
        <label class="key-label">Your API key could not be generated</label>
        <p class="kyc-verify-sub-label" fxLayoutGap="10px">Your KYC is not verified</p>
        <button type="button" mat-button class="kyc-btn" fxLayoutAlign="center center"
        style="padding:2px;background: #386AF6; color:#fff;border: 2px solid #386AF6; border-radius:25px; width:16vw">Check KYC status
        <mat-icon>
            chevron_right
        </mat-icon>
    </button>
    </div>
</div> -->

        